export default (input) => {
    return input.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&').replace(/\\\{.+?\\\}/g, '.+');
};



// WEBPACK FOOTER //
// ./map/utils/escapeRegExp.js